import { Checkmark16Filled, Circle16Regular } from '@/components/Icon'
import { taskTimelineStatus } from '@/features/chat/phase1/workStatusThoughts'
import styles from './thoughtchain.module.scss'

function ChecklistRow({ task }) {
  const done = taskTimelineStatus(task.status) === 'done'
  const Icon = done ? Checkmark16Filled : Circle16Regular
  return (
    <div className={styles.checkRow}>
      <span className={styles.checkIcon}>
        <Icon fontSize={16} />
      </span>
      <p className={`${styles.checkText} ${done ? styles.checkTextDone : ''}`}>
        {task.title}
      </p>
    </div>
  )
}

export default function TaskChecklist({ tasks = [] }) {
  return (
    <>
      {tasks.map((task) => (
        <ChecklistRow key={task.id} task={task} />
      ))}
    </>
  )
}
